// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bell-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.bell-btn {
  background: none;
  border: none;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.25rem;
  border-radius: 6px;
  transition: background 0.1s;
}
.bell-btn:hover {
  background: var(--surface-hover);
}
.bell-btn app-icon {
  font-size: 1.35rem;
  color: var(--text-secondary);
}
.bell-btn .badge {
  position: absolute;
  top: -0.15rem;
  right: -0.25rem;
  background: var(--color-danger);
  color: var(--text-on-dark);
  font-size: 0.55rem;
  font-weight: 700;
  border-radius: 50%;
  min-width: 1rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  padding: 0 0.15rem;
}

.notif-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10000;
}

.notification-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  width: 22rem;
  max-height: 26rem;
  background: var(--surface-primary);
  border: 1px solid var(--border-default);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  z-index: 10001;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.dropdown-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--border-default);
}
.dropdown-header span {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--text-primary);
}
.dropdown-header .mark-all-btn {
  background: none;
  border: none;
  color: var(--color-accent);
  font-size: 0.7rem;
  cursor: pointer;
  font-weight: 600;
}
.dropdown-header .mark-all-btn:hover {
  text-decoration: underline;
}

.notification-list {
  overflow-y: auto;
  flex: 1;
}

.notification-item {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  cursor: pointer;
  transition: background 0.1s;
}
.notification-item:hover {
  background: var(--surface-secondary);
}
.notification-item.unread {
  background: rgba(18, 100, 163, 0.06);
}
.notification-item .notif-icon {
  font-size: 1rem;
  color: var(--color-accent);
  margin-top: 0.1rem;
  flex-shrink: 0;
}
.notification-item .notif-body {
  flex: 1;
  min-width: 0;
}
.notification-item .notif-body .notif-sender {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--text-primary);
  display: block;
}
.notification-item .notif-body .notif-preview {
  font-size: 0.75rem;
  color: var(--text-secondary);
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.notification-item .notif-time {
  font-size: 0.6rem;
  color: var(--text-tertiary);
  flex-shrink: 0;
  margin-top: 0.1rem;
}

.empty-notifications {
  display: flex;
  justify-content: center;
  padding: 2rem 1rem;
}
.empty-notifications p {
  font-size: 0.85rem;
  color: var(--text-tertiary);
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/notification-bell/notification-bell.component.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;AADF;;AAIA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;AADF;AAGE;EACE,gCAAA;AADJ;AAIE;EACE,kBAAA;EACA,4BAAA;AAFJ;AAKE;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,+BAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAHJ;;AAOA;EACE,eAAA;EACA,QAAA;EACA,cAAA;AAJF;;AAOA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;EACA,kCAAA;EACA,uCAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,8CAAA;AAJF;AAME;EACE,iBAAA;EACA,gBAAA;EACA,0BAAA;AAJJ;AAOE;EACE,gBAAA;EACA,YAAA;EACA,0BAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AALJ;AAOI;EACE,0BAAA;AALN;;AAUA;EACE,gBAAA;EACA,OAAA;AAPF;;AAUA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;EACA,eAAA;EACA,2BAAA;AAPF;AASE;EACE,oCAAA;AAPJ;AAUE;EACE,oCAAA;AARJ;AAWE;EACE,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;AATJ;AAYE;EACE,OAAA;EACA,YAAA;AAVJ;AAYI;EACE,iBAAA;EACA,gBAAA;EACA,0BAAA;EACA,cAAA;AAVN;AAaI;EACE,kBAAA;EACA,4BAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAXN;AAeE;EACE,iBAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AAdF;AAgBE;EACE,kBAAA;EACA,2BAAA;EACA,SAAA;AAdJ","sourcesContent":["// Slack-inspired notification bell\n\n.bell-wrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.bell-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 0.25rem;\n  border-radius: 6px;\n  transition: background 0.1s;\n\n  &:hover {\n    background: var(--surface-hover);\n  }\n\n  app-icon {\n    font-size: 1.35rem;\n    color: var(--text-secondary);\n  }\n\n  .badge {\n    position: absolute;\n    top: -0.15rem;\n    right: -0.25rem;\n    background: var(--color-danger);\n    color: var(--text-on-dark);\n    font-size: 0.55rem;\n    font-weight: 700;\n    border-radius: 50%;\n    min-width: 1rem;\n    height: 1rem;\n    line-height: 1rem;\n    text-align: center;\n    padding: 0 0.15rem;\n  }\n}\n\n.notif-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n}\n\n.notification-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: 22rem;\n  max-height: 26rem;\n  background: var(--surface-primary);\n  border: 1px solid var(--border-default);\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n  z-index: 10001;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.dropdown-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--border-default);\n\n  span {\n    font-size: 0.9rem;\n    font-weight: 700;\n    color: var(--text-primary);\n  }\n\n  .mark-all-btn {\n    background: none;\n    border: none;\n    color: var(--color-accent);\n    font-size: 0.7rem;\n    cursor: pointer;\n    font-weight: 600;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.notification-list {\n  overflow-y: auto;\n  flex: 1;\n}\n\n.notification-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  padding: 0.6rem 1rem;\n  cursor: pointer;\n  transition: background 0.1s;\n\n  &:hover {\n    background: var(--surface-secondary);\n  }\n\n  &.unread {\n    background: rgba(18, 100, 163, 0.06);\n  }\n\n  .notif-icon {\n    font-size: 1rem;\n    color: var(--color-accent);\n    margin-top: 0.1rem;\n    flex-shrink: 0;\n  }\n\n  .notif-body {\n    flex: 1;\n    min-width: 0;\n\n    .notif-sender {\n      font-size: 0.8rem;\n      font-weight: 700;\n      color: var(--text-primary);\n      display: block;\n    }\n\n    .notif-preview {\n      font-size: 0.75rem;\n      color: var(--text-secondary);\n      display: block;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .notif-time {\n    font-size: 0.6rem;\n    color: var(--text-tertiary);\n    flex-shrink: 0;\n    margin-top: 0.1rem;\n  }\n}\n\n.empty-notifications {\n  display: flex;\n  justify-content: center;\n  padding: 2rem 1rem;\n\n  p {\n    font-size: 0.85rem;\n    color: var(--text-tertiary);\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
